import http from './http'

function getGroups () {
  return http({
    method: 'GET',
    url: '/groups'
  })
}

function createGroup (data) {
  return http({
    method: 'POST',
    url: '/groups',
    data
  })
}

function deleteGroup (id) {
  return http({
    method: 'DELETE',
    url: '/groups/' + id
  })
}

function editGroup (id, name) {
  return http({
    method: 'PATCH',
    url: '/groups/' + id + '/info',
    data: {
      name
    }
  })
}

function addGroupUsers (id, data) {
  return http({
    method: 'PUT',
    url: '/groups/' + id + '/users',
    data
  })
}

function deleteGroupUsers (id, data) {
  return http({
    method: 'DELETE',
    url: '/groups/' + id + '/users',
    data
  })
}

export {
  getGroups,
  createGroup,
  deleteGroup,
  editGroup,
  addGroupUsers,
  deleteGroupUsers
}



// WEBPACK FOOTER //
// ./src/services/api/group.js